// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title__+SKHg","swoosh":"SectionTitle_swoosh__qOi00"};